import { cn } from "@/lib/utils";

/** "Cure+" brand mark. `withWordmark` adds the product name beside the badge. */
export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5 font-bold tracking-tight", className)} aria-label="Cure+ Clinics">
      <span className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-primary to-accent shadow-soft" aria-hidden>
        <svg viewBox="0 0 24 24" className="h-5 w-5 text-white" fill="currentColor">
          <path d="M9.5 3h5v6.5H21v5h-6.5V21h-5v-6.5H3v-5h6.5z" />
        </svg>
      </span>
      {!compact && (
        <span className="text-xl leading-none text-foreground">
          Cure<span className="text-primary">+</span>
        </span>
      )}
    </span>
  );
}
